import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useMutation from "src/hooks/useMutation";
import {
  UPDATE_INTERNAL_WORK_ORDER_ITEM_MUTATION,
  CREATE_INVENTORY_TRANSACTION_MUTATION,
} from "src/constants/graphql/mutations";
import StorageLocationAutocomplete from "src/views/capture/RackLocations/StorageLocationAutocomplete/StorageLocationAutocomplete";

export default function ReturnToLocationModal({ item, asset, onClose }) {
  const [location, setLocation] = useState({
    warehouse: null,
    warehouse_locations: [],
    sub_qty: item.quantity,
  });
  const [saving, setSaving] = useState(false);
  const [updateItem] = useMutation(UPDATE_INTERNAL_WORK_ORDER_ITEM_MUTATION);
  const [createTransaction] = useMutation(CREATE_INVENTORY_TRANSACTION_MUTATION);

  const markCompleted = async () => {
    const { id, __typename, createdAt, requestedBy, attachments, ...input } = item;
    await updateItem({
      variables: {
        id,
        input: {
          ...input,
          completedStatus: true,
        },
      },
    });
  };

  const handleSubmitNewLocation = async () => {
    try {
      setSaving(true);
      const rackLocations = (asset?.rackLocations || []).map(l => ({ ...l }));
      const oldRackLocations = asset?.rackLocations || [];
      const rackLocationsChanges = [
        {
          ...location,
          sub_qty: item.quantity,
        },
      ];

      if (rackLocations.length) {
        rackLocations[0] = { ...rackLocations[0], ...location, sub_qty: item.quantity };
      } else {
        rackLocations.push({ ...location, sub_qty: item.quantity });
      }

      await createTransaction({
        variables: {
          code: asset.assetId,
          id: asset.id,
          quantity: 0,
          notes: "",
          senderName: "",
          carrierName: "",
          trackingNumber: "",
          orderNumber: "",
          poNumber: "",
          rackLocations,
          rackLocationsChanges,
          oldRackLocations,
          internalWorkOrderItemId: item.id,
          actionSource: "internal_work_order_return",
        },
      });

      await markCompleted();
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography align="center" fontSize={20} fontWeight={500} color="text.primary">
          Internal Work Order Assistant
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box py={6}>
          <Typography align="center" sx={{ mb: 2 }} color="text.primary" fontSize={18}>
            Which location are you returning this item to?
          </Typography>
          <StorageLocationAutocomplete
            name="location"
            value={location}
            projectId={asset?.project?.id}
            onChange={values => setLocation(prev => ({ ...prev, ...values }))}
            disabled={saving}
            loading={false}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmitNewLocation}
          disabled={!location?.warehouse?.id || !location?.warehouse_locations?.[0]?.id || saving}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
